var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoritesResponsive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.687 1c-1.085 0-2.08.35-2.958 1.042-.84.663-1.4 1.507-1.73 2.121-.33-.614-.89-1.458-1.73-2.121C8.39 1.35 7.395 1 6.31 1 3.28 1 .998 3.525.998 6.874c0 3.618 2.85 6.094 7.163 9.841.733.637 1.563 1.358 2.426 2.128a.617.617 0 0 0 .823 0c.863-.77 1.694-1.491 2.427-2.128C18.15 12.968 21 10.492 21 6.875 21 3.524 18.716 1 15.687 1z",
    stroke: "#191919",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesResponsive);
export default __webpack_public_path__ + "static/media/favorites-responsive.d0022474e33a19dba22587584b2ec137.svg";
export { ForwardRef as ReactComponent };